<div class="al-search-bar">
    <div class="bar-content" [ngStyle]="{'width': width}">
        <span class="ui-float-label">
            <input #searchBar [id]="inputId" type="text" [placeholder]="showLabel?'':placeholder"
                [formControl]="searchControl" (focusout)="onFocusOutEvent($event)" pInputText (keyup.enter)="executeSearch()"
                data-cy="search-bar-input">
            <label *ngIf="showLabel" for="al-search-input">{{placeholder}}</label>
            <i class="material-icons" [ngClass]="searchIcon" (click)="executeSearch()">search</i>
        </span>
        <div class="input-error"
            *ngIf="invalidPattern">
            {{invalidSearchPatternText}}
        </div>
    </div>
</div>
